import { Colors, Icon, Typography } from '@amelio/ui-library';

export type ConfidentialityNoticeProps = {
    message: string;
};

export const ConfidentialityNotice = ({ message }: ConfidentialityNoticeProps) => (
    <div className={'mt-2 flex items-center gap-2'}>
        <Icon
            name={'security-eye-slash'}
            color={Colors.WHITE}
            size={'sm'}
            className={'shrink-0'}
        />

        <Typography
            variant={'body-small'}
            color={Colors.WHITE}
            weight={'light'}
            className={'text-responsive-xs-sm'}
        >
            {message}
        </Typography>
    </div>
);
